
import React from 'react';
import { Line,Bar,Pie,Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

// Register the components you want to use
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
);

const LeadsPieChart = ({backgroundColor= [
    '#BB73FF',
    '#E7E8F2'

],conversionRate}) => {
    // console.log(conversionRate)
    const data =  {
        labels: [ ],
          datasets: [{
            label: ['Social Media',''],
            data: [conversionRate,100-conversionRate],
            backgroundColor:backgroundColor,
            hoverOffset: 4
          }]
    }

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
         
            
        },
        plugins: {
            legend: {
                display: false ,
                position:'bottom'
            }
        },
        cutout: '80%' 

    }


 return <Doughnut  data={data} options={options}   />;


};

export default LeadsPieChart;
